module.exports = __webpack_public_path__ + "img/security.f20fc38.svg";